import { createTheme, type MantineTheme, Table } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineTable: PartialDeep<MantineTheme> = createTheme({
  components: {
    Table: Table.extend({
      defaultProps: {
        highlightOnHover: true,
        highlightOnHoverColor: 'purple.0',
        horizontalSpacing: 'md',
        verticalSpacing: 'sm',
        tabularNums: true,
        striped: true,
      },
      styles: {
        td: {
          verticalAlign: 'middle', // Our reset sets this to baseline, which causes misalignment in tables
        },
      },
    }),
    TableThead: Table.Thead.extend({
      defaultProps: {
        bg: 'purple.1',
        style: theme => ({ borderBottom: `1px solid ${theme.colors.gray[2]}` }),
      },
    }),
    TableTh: Table.Th.extend({
      defaultProps: {
        c: 'purple.5',
        bg: 'purple.1',
        fz: 14,
        fw: 400,
        pt: 6,
        pb: 6,
      },
    }),
    TableTd: Table.Td.extend({
      defaultProps: {
        fz: 14,
      },
    }),
  },
});
